import { useContext } from "react"
import EditUserView from "./EditUserView"
import SelectUserView from "./SelectUserView"
import UsersPageContext from "./UsersPageContext"
import UsersSidebar from "./UsersSidebar"

type Props = {
  heroImage: string
  onUserSelect: (userEmail: string | undefined) => void
}

const UsersPageContent = ({ heroImage, onUserSelect }: Props) => {
  const { userHasChanges, selectedUserEmail } = useContext(UsersPageContext)

  const handleUserSelect = (userEmail: string) => {
    if (userHasChanges) {
      if (!window.confirm('This user has been edited.\n\nDiscard your changes and select a different user?')) {
        return
      }
    }

    onUserSelect(userEmail)
  }

  const pageContent = selectedUserEmail === undefined
    ? <SelectUserView />
    : <EditUserView
      heroImage={heroImage}
      onUserDeletionChange={() => onUserSelect(undefined)}
    />

  return <>
    <UsersSidebar
      onUserSelect={handleUserSelect}
    />
    <div id="main" className="main-template has-elements fluid-container">
      {pageContent}
    </div>
  </>
}

export default UsersPageContent